import { Link } from '@inertiajs/react';

export default function SearchCategories({ categories = [], onSelect }) {
    return (
        <div>
            <h3 className="mb-3 text-xs font-semibold tracking-[0.25em] text-muted-foreground uppercase">
                Browse Categories
            </h3>

            <div className="grid grid-cols-2 gap-2">
                {categories.map((category) => (
                    <Link
                        key={category.label}
                        href={category.href}
                        onClick={onSelect}
                        className="rounded-2xl border border-border px-4 py-3 text-sm font-medium transition focus:ring-2 focus:ring-ring focus:outline-none"
                    >
                        {category.label}
                    </Link>
                ))}
            </div>
        </div>
    );
}
